import Events from "./events";
import Sutikezeles from "./sutikezeles";
export default class PDApp {

    constructor() {
        this.init();
    }

    init() {
        let ev = new Events();
        ev.initAnimClassSetup();
        ev.initValtakozoSzoveg();
        ev.initMenuLinks();
        ev.initNyelvvalaszto();
        ev.initKapcsolatForm();
        ev.initProjectCards();

        let sutikezeles = new Sutikezeles();
        window.sutikezeles = sutikezeles;
        console.log('1')
    }



}

